module.exports = __webpack_public_path__ + "static/media/TV-Logo.9d5e6774.png";